import styled, { css } from "styled-components"
import breakpoint from "styled-components-breakpoint"
import { SelectField } from "../../forms"

export const ActionsContainer = styled.div`
  > * {
    width: 100%;
  }

  > :not(:last-child) {
    margin-bottom: 0.25rem;
  }

  ${breakpoint("tablet")`
    white-space: nowrap;

    > * {
      width: unset;
    }

    > :not(:last-child) {
      margin: 0;
      margin-right: 0.25rem;
    }
  `}

  ${({ simpleForm }) =>
    simpleForm &&
    css`
      display: flex;
      justify-content: start;
      gap: 0.7rem;
    `}
`

export const IconsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`

export const StyledSelectField = styled(SelectField)`
  border-radius: 0.5rem;
  border-width: 2px;
  border-color: ${({ theme }) => theme.colors.secondary};
  color: ${({ theme }) => theme.colors.secondaryAlternative || theme.colors.secondary};
  padding: 0px 6px 0px 0px;
  margin: 0;
  font-weight: bold;
  width: 6rem;
  height: 2.25rem;
  font-size: 0.75rem;
  display: flex;
  align-items: center;
  text-align: center;
  cursor: pointer;
`

export const NameWithIcon = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 500;

  svg {
    color: ${({ theme }) => theme.colors.primary};
  }

  p {
    margin: 0;
  }
`

export const StyledCurrencyValue = styled.span`
  color: ${({ $color }) => $color || "inherit"};
  font-weight: 700;
  font-size: 1.25rem;
  line-height: 1.75rem;

  ${({ positive }) =>
    positive
      ? css`
          color: #333;
        `
      : css`
          color: #497929;
        `}
`

export const StyledStatusText = styled.span`
  color: ${({ isDanger, theme }) => (isDanger ? theme.colors.alerts.danger : "inherit")};
`
